import { render, staticRenderFns } from "./FiltroLotes.vue?vue&type=template&id=196c9a3c&scoped=true"
import script from "./FiltroLotes.vue?vue&type=script&lang=js"
export * from "./FiltroLotes.vue?vue&type=script&lang=js"
import style0 from "./FiltroLotes.vue?vue&type=style&index=0&id=196c9a3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "196c9a3c",
  null
  
)

export default component.exports